import api from 'config/Api/Api';
import { formatFormDataBody } from 'utils';

const baseEndpoint = 'v1/campaigns';
const baseEndpointWizard = 'v1/wizard-campaign';

export default {
  getCampaigns( params ) {
    return api.get( baseEndpoint, params );
  },

  getCampaign( id ) {
    return api.get( `${baseEndpoint}/${id}` );
  },

  getCampaignLogs( id, processCdr ) {
    // eslint-disable-next-line quotes
    const processCdrParam = processCdr ? "?processCdr=true" : "";
    return api.get( `${baseEndpoint}/${id}/cdrs${processCdrParam}` );
  },

  updateCampaign( id, data ) {
    return api.put( `${baseEndpoint}/${id}`, data );
  },

  deleteCampaign( id ) {
    return api.delete( `${baseEndpoint}/${id}` );
  },

  getWizardCampaign() {
    return api.get( baseEndpointWizard );
  },

  exportExcel( id, params ) {
    return api.get( `${baseEndpoint}/${id}/export-excel`, params );
  },

  saveWizardCampaignStep1( data ) {
    return api.post( `${baseEndpointWizard}/step1`, data );
  },

  updateWizardCampaignStep1( id, data ) {
    return api.put( `${baseEndpointWizard}/${id}/step/step1`, data );
  },

  saveWizardCampaignMedia( id, data ) {
    return api.post(
      `${baseEndpointWizard}/${id}/media-audio`,
      formatFormDataBody( data ),
    );
  },

  validatePhone( id, data ) {
    return api.post( `${baseEndpointWizard}/${id}/validate-phone-number`, data );
  },

  uploadPhoneFile( id, data ) {
    return api.post(
      `${baseEndpointWizard}/${id}/list-phone-number`,
      formatFormDataBody( data ),
    );
  },

  validateCost( id, data ) {
    return api.post( `${baseEndpointWizard}/${id}/validate-cost-time`, data );
  },

  saveCampaign( id, data ) {
    return api.put( `${baseEndpointWizard}/${id}`, data );
  },

  saveFavouriteAudio( id, data ) {
    return api.post( `${baseEndpointWizard}/${id}/favourite-media-audio`, data );
  },

  saveFavouritePhones( id, data ) {
    return api.post(
      `${baseEndpointWizard}/${id}/favourite-list-phone-number`,
      data,
    );
  },

  getCrmData( id, data ) {
    return api.post( `${baseEndpointWizard}/${id}/crm-data`, data );
  },
};
